<template>
  <div>
    <form @submit.prevent>
      <fields-list :fields="fields" :item="item" />
      <div class="clearfix"></div>
      <div class="save-group">
        <p-button
          class="btn btn-info mt-4"
          type="info"
          @click.native.prevent="addItem"
        >
          <span class="ti-plus"></span>
          {{ "next_step" | setText("Далее") }}</p-button
        >
      </div>
    </form>
  </div>
</template>
<script>
import { errorNotify, multiKeyInit, cardUpdate } from "@/plugins/functions";

export default {
  created() {
    let item = {};
    this.fields = [];
    this.fields = this.fieldsFrom.slice();

    for (let i = 0; i < this.fields.length; i++) {
      item[this.fields[i].key] = "";
    }

    this.item = this.multiKeyInit(item, this, 0);
  },
  data() {
    return {
      item: {},
      fields: [],
    };
  },
  props: {
    setLink: {
      default: "",
    },
    cardLink: {
      default: "",
    },
    openItem: {
      default: true,
    },
    modalTitle: {
      default: "Новый элемент",
    },
    modalCreate: {
      default: "",
    },
    fieldsFrom: {
      type: Array,
      default: {
        function(prams) {
          return [];
        },
      },
    },

    onCreateOpen: {
      default: true,
    },
    getList: {
      default: function () {
        return false;
      },
    },
  },
  methods: {
    multiKeyInit: multiKeyInit,
    errorNotify: errorNotify,
    cardUpdate: cardUpdate,
    close() {
      this.item = {};
      this.$emit("close", true);
    },
    modalOpen() {},
    async addItem() {
      let item = await this.cardUpdate(
        this.setLink,
        this.item,
        this.fields,
        "POST"
      );

      if (item && item.id) {
        //close modal service
        let query = Object.assign({}, this.$route.query);
        if (query["item_order_service"]) {
          delete query["item_order_service"];
        }
        setTimeout(() => {
          this.$router.replace({ query: query });
        }, 0);

        this.$emit("input", item);
      }
    },
  },
};
</script>